import { PlaySVG } from 'common-helpers/img';
import Button from 'components/Button';
import { ArrowIcon } from 'components/Icons';
import React from 'react';
import styled from 'styled-components';
import { TYPE } from 'theme';
import { scrollToVideo } from './utils';
import { AIRDROP_URL } from 'constant';
import { AutoColumn } from 'components/Column';

const StyledLanding = styled.div`
    position: relative;
    z-index: 2;
    // height: 623px;
    margin: 0 auto;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 454px;
        background-position: center bottom;
        background-size: contain;
        border-bottom: none;
    `};
`;

const Title = styled.div`
    padding-top: 140px;
    padding-bottom: 77px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    opacity: 0;
    animation: fadeIn 2s ease-out forwards;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding-top: 60px;
        // padding-bottom: 20px;
        // gap: 20px;
        align-items: center;
        text-align: center;
    `};
`;

// const StyledPlayIcon = styled(PlaySVG)`
//     width: 20px;
//     height: 20px;
//     margin-left: 6px;
//     ${({ theme }) => theme.mediaWidth.upToSmall`
//         width: 14px;
//         height: 14px;
//     `};
// `;

const StyledTitleButton = styled(Button)`
    border-radius: 20px;
    padding: 0;
    font-size: 14px;
    cursor: pointer;
    width: 224px;
    & > div {
        padding: 10px 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin: 20px 0;
    `};
`;
const TitleButtonArrow = styled.div`
    padding: 5px 8px;
    margin-left: 16px;
    border-radius: 10px;
    display: inline-block;
    color: #000;
    background-color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

const StyledVideoButton = styled(Button)`
    border-radius: 20px;
    padding: 8px 20px;
    font-size: 14px;
    width: 224px;
`;

const TitleButton = () => {
    return (
        <StyledTitleButton type="gradient" size="unset" onClick={() => window.open(AIRDROP_URL, '_blank')}>
            <div>
                <span>Claim $GOATED Airdrops</span>
                <TitleButtonArrow>
                    <ArrowIcon color="#000" />
                </TitleButtonArrow>
            </div>
        </StyledTitleButton>
    );
};

const Landing = () => {
    return (
        <StyledLanding>
            <Title>
                <div>
                    <TYPE.main
                        color="#fff"
                        fontSize={60}
                        mobileFz={40}
                        lineHeight={1.35}
                        fontWeight={700}
                        marginTop={40}
                    >
                        GOAT ONE PIECE PROJECT
                    </TYPE.main>
                    <TYPE.main color="#fff" fontSize={48} mobileFz={24} lineHeight={1} fontWeight={700} marginTop={10}>
                        EXPLORE THE UNIVERSE
                    </TYPE.main>
                </div>
                <AutoColumn gap="40px">
                    <TYPE.main color="#fff" fontSize={20} mobileFz={14} lineHeight={1} fontWeight={400}>
                        Growth, Community, Rewards
                    </TYPE.main>
                    <TYPE.main color="#fff" fontSize={20} mobileFz={14} lineHeight={1} fontWeight={400}>
                        Season 4 Airdrop Claim: 2026 April 22 – 2026 July 21
                    </TYPE.main>
                    <TitleButton />
                    {/* <StyledVideoButton type="outlineWhite" size="unset" onClick={scrollToVideo}>
                    Watch Our Adventures <StyledPlayIcon />
                </StyledVideoButton> */}
                </AutoColumn>
            </Title>
        </StyledLanding>
    );
};

export default Landing;
